import {
    styled,
    StyledGreenInputField,
    StyledInput,
    StyledVideo,
} from '@raskrask-dk/rr-components'

export const StyledIcons = styled('div', {
    display: 'flex',

    '@mobile': {
        gap: 16,
    },
    '@desktop': {
        gap: 32,
    },
})

export const StyledAddressField = styled('div', {
    maxW: 600,
    position: 'relative',
    w: '100%',
    zIndex: '$dropdown',

    '.dawa-autocomplete-suggestions': {
        bgc: '$white',
        borderBottom: '1px solid $neutral200',
        br: '$1',
        left: 0,
        m: 0,
        maxH: 250,
        overflowY: 'auto',
        p: 0,
        position: 'absolute',
        right: 0,
        textAlign: 'left',
        top: '100%',
        zIndex: '$dropdown',

        '.dawa-autocomplete-suggestion': {
            border: '1px solid $neutral200',
            borderBottomWidth: 0,
            color: '$primary600',
            cursor: 'pointer',
            listStyle: 'none',
            m: 0,
            p: '$2',

            '&:first-child': {
                borderTopLeftRadius: 'inherit',
                borderTopRightRadius: 'inherit',
            },

            '&:last-child': {
                borderBottomLeftRadius: 'inherit',
                borderBottomRightRadius: 'inherit',
            },

            '&.dawa-selected, &:hover': {
                bgc: '$primary200',
                color: '$primary600',
                fontWeight: 600,
            },
        },
    },

    variants: {
        showError: {
            true: {
                [`& ${StyledInput}`]: {
                    color: '$error500',
                    border: '1px solid $error500',

                    '&::placeholder': {
                        color: '$error500',
                    },

                    '&:focus, &:hover': {
                        border: '1px solid $error500',

                        '&::placeholder': {
                            color: '$error500',
                        },
                    },
                },
            },
        },
    },
})

export const StyledAddressStep = styled('div', {
    alignContent: 'center',
    background:
        'url(https://www.raskrask.dk/wp-content/uploads/2019/10/DSC04184-e1611581144950.jpg.webp)',
    backgroundSize: 'cover',
    display: 'grid',
    gap: 16,
    p: 16,
    justifyItems: 'center',
    position: 'relative',

    '&:after': {
        background: 'linear-gradient(0deg, #276A82B3, #276A82B3)',
        bottom: 0,
        content: '',
        left: 0,
        position: 'absolute',
        right: 0,
        top: 0,
        zIndex: 2,
    },

    [`& ${StyledVideo}`]: {
        position: 'absolute',
        w: '100%',
        zIndex: 1,
    },

    [`& ${StyledGreenInputField}, & ${StyledIcons}`]: {
        zIndex: 3,
    },

    '@mobile': {
        minH: 300,
    },

    '@desktop': {
        aspectRatio: '1473 / 613',
    },
})

export const ErrorText = styled('div', {
    alignItems: 'center',
    bgc: 'rgba(16, 41, 52, .8)',
    borderBottomLeftRadius: '$1',
    borderBottomRightRadius: '$1',
    color: '$error600',
    display: 'flex',
    position: 'absolute',
    gap: '$2',
    p: '$2',
    left: 0,
    right: 0,
})
